export const APP_BAR_HEIGHT = 88;
export const FONT_FAMILY = "'Inter', sans-serif";
